import React from 'react';
import PropTypes from 'prop-types';

import './Video.scss';

export const Video = ({ videoId, title, sectionTitle }) => {
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <section className='video-section'>
      <h2>{sectionTitle}</h2>
      <div className='video-container'>
        <iframe
          src={embedUrl}
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
          title={title}
        />
      </div>
    </section>
  );
};

Video.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
};

export default Video;
